// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2QMsC","calendarButtons":"ClockData_calendarButtons__3tJtE"};